import React from 'react'
import './card-dash-journey.css'

const CardDashJourney = props => {
    const data = props.data
    return (
        <div className='card-dash-journey-container'>
            <div className='card-dash-journey-content'>
                <div className={`card-dash-journey-principal-icon ${data.icon}`}></div>
                <div className='card-dash-journey-values'>
                    <span className='card-dash-journey-val'>{data.value}</span>
                    <span className='card-dash-journey-label'>{data.label}</span>
                </div>

            </div>
            <div className='card-dash-journey-legend' style={{ backgroundColor: data.legend.color }}>

                <span className='card-dash-journey-legend-label'>{data.legend.label}</span>
                {data.legend.icon ? (
                    <div className={`card-dash-journey-legend-icon ${data.legend.icon}`}>
                    </div>
                ) : null}

            </div>
        </div>
    )
}

export default CardDashJourney